/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { TechwiseOffice, VersionedPagination } from "../../utils/Interfaces";

export interface TechwiseOfficesState {
    existingTechwiseOffices: TechwiseOffice[];
    existingTechwiseOfficesCount: number;
    existingTechwiseOfficesLoaded: boolean;
    existingTechwiseOfficesVersion: string;
}

const initialState: TechwiseOfficesState = {
    existingTechwiseOffices: [],
    existingTechwiseOfficesCount: 0,
    existingTechwiseOfficesLoaded: false,
    existingTechwiseOfficesVersion: "",
};

export const techwiseOfficesSlice = createSlice({
    name: "techwise_offices",
    initialState,
    reducers: {
        setExistingTechwiseOffices: (state, action: PayloadAction<VersionedPagination<TechwiseOffice>>) => {
            state.existingTechwiseOffices = action.payload.results;
            state.existingTechwiseOfficesCount = action.payload.count;
            state.existingTechwiseOfficesLoaded = true;
            state.existingTechwiseOfficesVersion = action.payload.version;
        },
    },
});

export const { setExistingTechwiseOffices } = techwiseOfficesSlice.actions;

export const selectExistingTechwiseOffices = (state: RootState) => state.locations.existingTechwiseOffices;
export const selectExistingTechwiseOfficesCount = (state: RootState) => state.locations.existingTechwiseOfficesCount;
export const selectExistingTechwiseOfficesLoaded = (state: RootState) => state.locations.existingTechwiseOfficesLoaded;
export const selectExistingTechwiseOfficesVersion = (state: RootState) => state.locations.existingTechwiseOfficesVersion;

export default techwiseOfficesSlice.reducer;
